<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      class="left-menu"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      text-color="#ffffff"
      active-text-color="#ffffff">
      <!-- <div class="menu-logo">
        <img width="100%" :src="logo">
      </div> -->
      <side-bar-item
        v-for="route in routes"
        :key="route.path"
        :item="route"
        :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex';
import SideBarItem from './side-bar-item.vue';

export default {
  components: { SideBarItem },
  data() {
    return {
      simpleLogo: null,
      // logo: systemConfig.logo && /^http[s]?:\/\//.test(systemConfig.logo) ?
      //   systemConfig.logo :
      //   require(`@/assets/${systemConfig.logo || 'logo'}.png`), // eslint-disable-line
    };
  },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      return this.$router.options.routes;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
